var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpertReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1903_5513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.1665H5C4.55797 4.1665 4.13405 4.3421 3.82149 4.65466C3.50893 4.96722 3.33333 5.39114 3.33333 5.83317V15.8332C3.33333 16.2752 3.50893 16.6991 3.82149 17.0117C4.13405 17.3242 4.55797 17.4998 5 17.4998H9.7475",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6665V14.9998H18.3333",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.1665V5.83317C15 5.39114 14.8244 4.96722 14.5118 4.65466C14.1993 4.3421 13.7754 4.1665 13.3333 4.1665H11.6667",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.16667C6.66667 3.72464 6.84226 3.30072 7.15482 2.98816C7.46738 2.67559 7.89131 2.5 8.33333 2.5H10C10.442 2.5 10.866 2.67559 11.1785 2.98816C11.4911 3.30072 11.6667 3.72464 11.6667 4.16667C11.6667 4.60869 11.4911 5.03262 11.1785 5.34518C10.866 5.65774 10.442 5.83333 10 5.83333H8.33333C7.89131 5.83333 7.46738 5.65774 7.15482 5.34518C6.84226 5.03262 6.66667 4.60869 6.66667 4.16667Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.9998C11.6667 15.8839 12.0179 16.7317 12.643 17.3569C13.2681 17.982 14.1159 18.3332 15 18.3332C15.8841 18.3332 16.7319 17.982 17.357 17.3569C17.9821 16.7317 18.3333 15.8839 18.3333 14.9998C18.3333 14.1158 17.9821 13.2679 17.357 12.6428C16.7319 12.0177 15.8841 11.6665 15 11.6665C14.1159 11.6665 13.2681 12.0177 12.643 12.6428C12.0179 13.2679 11.6667 14.1158 11.6667 14.9998Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.1665H10",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 12.5H9.16667",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1903_5513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertReport);
export default __webpack_public_path__ + "static/media/expertReport.07302efe086292178efeedf4b833283b.svg";
export { ForwardRef as ReactComponent };